import React, { useContext, useState } from 'react';

import { Table, Icon } from 'semantic-ui-react';

import _isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';

import PlaceActionEditModal from 'components/modules/business-profile/components/PlaceActionEditModal';
import { PlaceActionsContext } from 'components/modules/business-profile/contexts/PlaceActions.context';
import { ProviderEntityAttributesPropType } from 'components/modules/business-profile/types/place-action.types';
import useNavigation from 'components/modules/navigation/hooks/use-navigation';
import { selectWebsitePages } from 'selectors/website';

import { formatPlaceActionType } from '../../PlaceActionsTable.utils';

import './PlaceActionTableRow.scss';

const propTypes = {
  placeAction: ProviderEntityAttributesPropType.isRequired,
};

const defaultProps = {};

export default function PlaceActionTableRow({ placeAction }) {
  const pages = useSelector(selectWebsitePages);

  const { getPageUrl: getCompletePageUrl } = useNavigation({ initialFetch: false });

  const { onSavePlaceAction, onClearPlaceAction } = useContext(PlaceActionsContext);

  const { objectId: pageId, attributes } = placeAction || {};
  const { uri, placeActionType, isPreferred } = attributes || {};
  const [isModalOpen, setIsModalOpen] = useState(false);

  function onEdit() {
    setIsModalOpen(true);
  }

  function handleModalClose() {
    setIsModalOpen(false);
  }

  const isAssigned = !_isEmpty(uri);

  const page = pages.find((p) => p.id === pageId);
  const { href: completePageUrl } = getCompletePageUrl(page);

  const finalUrl = !_isEmpty(page) ? completePageUrl : uri;

  return (
    <>
      <Table.Row className="place-action-table-row">
        <Table.Cell className="place-action-type">
          {formatPlaceActionType(placeActionType)}
        </Table.Cell>
        <Table.Cell className="uri">
          {isAssigned && (
            <a href={finalUrl} target="_blank" rel="noopener noreferrer">
              {finalUrl}
            </a>
          )}
          {!isAssigned && 'None'}
        </Table.Cell>
        <Table.Cell className="is-preferred">
          {isAssigned && isPreferred && 'Yes'}
          {isAssigned && !isPreferred && 'No'}
        </Table.Cell>
        <Table.Cell className="edit" textAlign="center">
          <Icon name="pencil" link className="edit-icon" onClick={onEdit} />
        </Table.Cell>
      </Table.Row>

      {isModalOpen && (
        <PlaceActionEditModal
          open={isModalOpen}
          onClose={handleModalClose}
          placeAction={placeAction}
          onSave={onSavePlaceAction}
          onClear={onClearPlaceAction}
        />
      )}
    </>
  );
}

PlaceActionTableRow.propTypes = propTypes;
PlaceActionTableRow.defaultProps = defaultProps;
